import ReactDOM from "react-dom";
import React from "react";
import Game from "game_play/model/big_round";
import ScoreView from "./score_view";
import ScoreTable from "./score_table";
import {createStore, withStore} from "game_play/utils/store";

// const $scoreView = document.querySelector('#react-stats-avg');
const $scoreView = document.querySelector('#react-score-view');
const $scoreTable = document.querySelector('#react-score-table');

class GameView extends React.Component {
  componentDidMount() {
    const {Game} = this.props;
    this._unsubscribe = Game.subscribe()
    Game.fetch()
  }

  componentWillUnmount() {
    this._unsubscribe()
  }

  render() {
    return (
      <>
        {$scoreView && ReactDOM.createPortal(
          <ScoreView/>,
          $scoreView
        )}
        {$scoreTable && ReactDOM.createPortal(
          <ScoreTable/>,
          $scoreTable
        )}
      </>
    )
  }
}

function fabricModalView(models = {}, params = {}) {
  return createStore(withStore(GameView), Object.assign({
    Game
  }, models), Object.assign({
    game: window.INIT_DATA || {}
  }, params))
}

export {fabricModalView}

export default fabricModalView({
  Game
}, {
  game: window.INIT_DATA || {}
})